/**
 * Vector tiles encode nested properties as JSON strings. Returns the parsed value
 * for strings and passes everything else through unchanged.
 */
export function parseIfString<T>(value: T): T {
  return (typeof value === 'string' ? JSON.parse(value) : value) as T
}
